module.exports = __webpack_public_path__ + "img/2subway4_long.07d4c427.jpg";